<template>
    <div class="">
        <div class='topHiehgt' :class="$iosTopHeight()"></div>
        <div class="allHeight" v-if="classes"></div>
        <div class="head" :class="[$iosTopHeight('margin')]" :style="{ background: headInfo.headColor }">
            <div v-if="headType"><slot name='slotTemplate'></slot></div>
            <div v-else>
                <van-nav-bar
                    :class="{navBar: headShow}"
                    :title="headInfo.title"
                    :right-text='headInfo.rightText'
                    :border='borderShow'
                    @click-left="onClickLeft"
                    @click-right="onClickRight"
                    :left-arrow='leftArrowShow'>
                    <template v-if="slotShow" #right>
                        <slot name="iconImg">
                            <div class="iconImg"><img src="../../assets/img/b2b/icon_search@2x.png" alt=""></div>
                        </slot>
                    </template>
                </van-nav-bar>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        // 兼容全部商品的页面头部高度
        classes: {
            type: String,
            default: ''
        },
        // 区分头部
        headType: {
            type: String,
            default: ''
        },
        // 头部显示信息
        headInfo: {
            type: Object,
            default: () => {
                return {}
            }
        },
        // 是否显示左侧箭头
        leftArrowShow: {
            type: Boolean,
            default: true
        },
        // 是否显示下边框
        borderShow: {
            type: Boolean,
            default: true
        },
        // 头部的背景色和字体颜色
        headShow: {
            type: Boolean,
            default: false
        },
        // 是否开启右侧插槽
        slotShow: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        onClickRight () {
            this.$emit('onClickRight')
        },
        onClickLeft () {
            this.$emit('onClickLeft')
        }
    }
}
</script>

<style lang="scss" scoped>
.topHiehgt {
    height: 88px;
}
.allHeight {
    height: 88px;
}
.iconImg {
    height: 88px;
}
.head {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    background-color: #fff;
    &.headColor {
        background: none;
    }
}
.navBar {
    background: none;
    /deep/ .van-nav-bar__title {
        color: #ffffff;
    }
    /deep/ .van-nav-bar__arrow {
        color: #ffffff;
    }
}
/deep/ .van-nav-bar {
    height: 88px;
    line-height: 88px;
}
/deep/ .van-nav-bar__left,
/deep/ .van-nav-bar__right,
/deep/ .van-nav-bar__title,
/deep/ .van-nav-bar__arrow {
    color: #333;
    font-size: 36px;
}
/deep/ .van-nav-bar__arrow {
    font-size: 44px;
}
/deep/ .van-nav-bar__text {
    color: #ff7a45;
    font-size: 32px;
}
/deep/ .van-hairline--bottom::after {
    border-color: #d1d1d6;
}
/deep/ .van-nav-bar__content {
    height: inherit;
}
</style>